import EditIcon from '@/shared/assets/icons/EditIcon.svg';
import FileTextIcon from '@/shared/assets/icons/FileTextIcon.svg';
import FolderIcon from '@/shared/assets/icons/Folder.svg';
import KeySquareIcon from '@/shared/assets/icons/KeySquareIcon.svg';
import LockIcon from '@/shared/assets/icons/LockIcon.svg';
import TableIcon from '@/shared/assets/icons/TableIcon.svg';

type SvgIcon = typeof FileTextIcon;

export type DirectoryTypeIconId =
  | 'folder'
  | 'document'
  | 'matrix'
  | 'matrixArchived'
  | 'record'
  | 'recordArchived';

/**
 * `matrixArchived` e `recordArchived` só têm consumidor na Legenda: a árvore não sabe se um item
 * está arquivado, porque `DirectoryTreeNode` não carrega essa informação.
 */
export const DIRECTORY_TYPE_ICONS: Record<DirectoryTypeIconId, SvgIcon> = {
  folder: FolderIcon,
  document: FileTextIcon,
  matrix: TableIcon,
  matrixArchived: LockIcon,
  record: EditIcon,
  recordArchived: KeySquareIcon,
};

export const DIRECTORY_LEGEND_ITEMS: { iconId: DirectoryTypeIconId; label: string }[] = [
  { iconId: 'document', label: 'Documento' },
  { iconId: 'matrix', label: 'Matriz' },
  { iconId: 'matrixArchived', label: 'Matriz arquivada' },
  { iconId: 'record', label: 'Registro gerado' },
  { iconId: 'recordArchived', label: 'Registro gerado arquivado' },
];
